<template>
    <div class="footer_bot">
        <div class="main">
            <div class="l">
                <div class="site">
                    <p> 
                        <a v-for="(item, index) in arr" :key="index" :href="item.url" :class="index===0?'':'contact'">{{item.title}}</a>
                    </p>
                </div>
                <div class="line"/>
                <div class="copy">IFMA国际财务管理协会中方机构 & IFM国际财务管理师资格认证 授权由国际财务管理协会北京代表处运营 <a href="https://beian.miit.gov.cn/" style="color:#fff" target="_blank">京ICP备2022032171号-1</a>
                    <br>地址：北京市西城区复兴门内大街45号院 100031 办公室电话：86-10-67571388
                    <br>© 2005-2016 International Financial Management Association (IFMA China) All Right Reserved
                </div>
                <div class="line"/>
                <div class="copy" style="margin-top:12.5px">
                    IFMA and IFM logo ownership is International Financial Management
                    <br>Association(IFMA),Without permission, he may not use it.
                    <br>IFMA和IFM 图形标识所有权属国际财务管理协会（IFMA），未经许可，不得他用。
                    <br>网站备案号 <a href="https://beian.miit.gov.cn/">京ICP备2022032171号-1</a>
                    <br>京公网安备 11010202009363号
                </div>
            </div>
            <div class="r">
                <!-- <div class="qrcode">
                    <img src="">
                    <div>公众号</div>
                </div>
                <div class="qrcode" style="margin-left:20px">
                    <img src="">
                    <div>客服号</div>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            arr:[
                {title:'首页', url:'/'},
                {title:'关于协会', url:'/aboutISOC'},
                {title:'IFM考试', url:'/ifmExam'},
                {title:'新闻中心', url:'/info?type=0'},
                {title:'学习系统', url:'/course?type=0'},
                {title:'考试系统', url:'/myexams'},
                {title:'IFM雇主', url:'/authorizedUnit'},
                {title:'授权机构', url:'/enrollStudent'},
                {title:'证书查询', url:'/certificateQuery'},
                {title:'联系我们', url:'/contact'},
                {title:'IFM Global', url:'https://ifmweb.org/'},
            ]
        }
    },
    methods: {
        tiaozhuan(){
            console.log('tiaozhuan')
            window.location.href='https://beian.miit.gov.cn/'
        }
    },
}
</script>
<style lang="scss" scoped>
a,a:link { cursor:pointer; color: #FFF;text-decoration: none;}
a:hover{ text-decoration: none; color:#fff;}
.line{
    width: 950px;
height: 1px;
opacity: 0.3;
background: #979797;
}
.footer_bot{
    padding: 38px 0;
    background: #464646;
    color: #fff;
    font-family: "Microsoft YaHei","微软雅黑" !important;
}
.main{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 1120px;
    margin: auto;
    .l{
        text-align: left;
        width: 950px;
        .site {
            p .contact{
                margin-left: 27px;
            }
            padding-bottom: 19.5px;
            font-family: PingFangSC-Regular;
            font-size: 16px;
            span {
                padding: 0 20px;
            }
        }
        .ba {
            font-size: 14px;
            color: #66809a;
        }
        .copy {
            padding-bottom: 12.5px;
            letter-spacing: 0.4px;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 24px;
            margin-top: 17px
        }
    }
    .r{
        text-align: right;
        width: 250px;
        padding-left: 40px;
        .qrcode{
            width: 69px;
            display: inline-block;
            vertical-align: top;
            img{
                width:69px;
                height:69px;
            }
            div{
                width: 100%;
                text-align: center;
                font-size: 12px;
                color: #FFFFFF;
            }
        }
        
    }
}

</style>
